import { API_PATH } from '@/shared/constants/api'
import { RENTERS_CLAIMS_FOLDER_ID } from '@/shared/constants/claims'
import { apiRequest } from '@/shared/helpers/api-request'
import {
  directusRequest,
  directusUpload,
} from '@/shared/helpers/directus-request'
import type { RentersClaim } from '@/shared/types/global.types'

export type CreateRentersClaimBody = {
  customer_description: string
  date_of_loss: string
  policy_id_ci: string
  latest_phone_number: string
  attachments: { create: { directus_files_id: string }[] }
}

export type UpdateUserProfileBody = {
  givenName: string
  surname: string
  phone: string
}

export async function uploadRentersClaimFile(file: File): Promise<string> {
  const formData = new FormData()
  // Directus reads `folder` only when it comes before the file part
  formData.append('folder', RENTERS_CLAIMS_FOLDER_ID)
  formData.append('file', file, file.name)
  const uploaded = await directusUpload<{ id: string }>(
    API_PATH.DIRECTUS_FILES,
    formData,
  )
  return uploaded.id
}

export function createRentersClaim(
  body: CreateRentersClaimBody,
): Promise<RentersClaim> {
  return directusRequest<RentersClaim>(API_PATH.RENTERS_CLAIMS, 'POST', body)
}

export async function updateUserProfile(
  token: string,
  body: UpdateUserProfileBody,
): Promise<void> {
  await apiRequest<void>(API_PATH.UPDATE_USER_PROFILE, token, 'PUT', body)
}
